import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from 'components/button/button'
import Icon from 'components/icon/icon'

import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import {
    getCurrentUser,
    getCurrentAccount
} from 'state/selectors'

import {
    openModal,
    cancelPremium
} from 'state/actions'

import moment from 'moment'

import { 
    getMobileOperatingSystem
} from 'utils'

import {
	isCordova
} from 'env'

class ModalTrialOver extends Component {
    enterBilling = _ => {
        const {
            openModal
        } = this.props

        setTimeout(_ => {
            openModal('upgrade', 'account')
        }, 150)
    }

    openContact = _ => {
        const {
            userData
        } = this.props

        window.open(`https://hassl.co/contact/?email=${userData.email}&username=${userData.first_name+'%20'+userData.last_name}`, '_blank')
    }

    downgrade = _ => {
        const {
            openModal,
            cancelPremium,
            accountData
        } = this.props

        setTimeout(_ => {
            openModal('confirm', 'confirm', {
                title: 'Downgrade to Hassl Standard?',
                text: `Business features will be turned off, and all private projects become visible to the rest of your organization. Continue?`,
                buttons: [
                    {
                        label: 'Yep',
                        level: 'high',
                        callback: _ => {
                            cancelPremium(accountData, _ => {
                                openModal('confirm', 'confirm', {
                                    text: `${accountData.name} has been downgraded to Hassl Standard.`
                                })
                            })
                        }
                    }, {
                        label: 'Continue on Hassl',
                        level: 'low',
                        callback: _ => {
                            setTimeout(_ => {
                                openModal('upgrade', 'account')
                            }, 100)
                        }
                    }
                ]
            })
        }, 150)
    }

    getSingleUnitPrice = _ => {
        const {
            planAndCurrencyData,
            accountData
        } = this.props

        if(!planAndCurrencyData){
            return '$6.00'
        }

        const {
            symbol
        } = planAndCurrencyData

        return (accountData.currency || symbol)+(accountData.billing_is_annual ? 60 : 6)
    }

	render() {
        const {
            userData
        } = this.props

		const os = getMobileOperatingSystem()

        const isIos = (os && os === 'iOS' && isCordova)

        if(!userData){
            return null
        }

		return(
			<div className="modal-trial-over">
                <h2>
                    That's a wrap, { userData.first_name }!
                </h2>
                <p>
                    Enjoy your trial? Add billing details, and get straight back to it for {this.getSingleUnitPrice()} per user.
                </p>
                { isIos ?
                    <div className={'ios-block'}>
                        <p>
                            Please come back on a desktop or mobile browser complete billing.
                        </p>
                        <Button 
                            size={'big'} 
                            level={'high'} 
                            link={`https://app.hassl.co`}
                            label={'Open app in browser'} 
                        />
                    </div>
                :
                    <Button 
                        size={'big'} 
                        level={'high'} 
                        callback={this.enterBilling} 
                        label={'Add billing details'} 
                    />
                }
                <div className="form-row">
                    <button onClick={this.openContact}>
                        Need a hand with anything?
                    </button>
                </div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
        userData: getCurrentUser(state),
        accountData: getCurrentAccount(state),
        allProjects: state.account.entities.projects,
		planAndCurrencyData: state.auth.planAndCurrencyData,
	}
}

export default withRouter(connect(mapStateToProps, { 
    openModal,
    cancelPremium
})(ModalTrialOver))


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-trial-over.jsx